export default {
  BandwidthUsageRanking: "带宽使用排行",
  BranchLinkQuality: "分支链路质量",
  GatewayExceptionTracking: "网关异常跟踪",
  To: "至",
  _BandwidthUsageRanking: {
    UplinkBandwidthUsageRate: "上行峰值带宽使用率%",
    DownlinkBandwidthUsageRate: "下行峰值带宽使用率%",
    PeakUplinkBandwidth: "上行带宽峰值",
    AverageUplinkBandwidth: "平均上行带宽",
    PeakDownlinkBandwidth: "下行带宽峰值",
    AverageDownlinkBandwidth: "平均下行带宽",
    AllFlow: '总流量',
  },
  _BranchLinkQuality: {
    BranchCPEHostName: "分支cpe主机名",
    HeadquartersCPEHostName: "总部cpe主机名",
    AverageLatency: "平均时延ms（到总部）",
    AveragePacketLoss: "平均丢包%（到总部）",
    AverageJitterMs: "平均抖动ms（到总部）",
    LinkQality: "链路质量（到总部）",
    ReferenceDelay: "参考时延ms（到总部）",
  },
  _GatewayExceptionTracking: {
    ServiceExceptionTime: '服务异常时间',
    ServiceRecoveryTime: '服务恢复时间',
    Duration: '持续时间min',
  },
}
